import {Injectable} from '@angular/core';
import {State} from '../models/State';

declare let _: any;

@Injectable({
  providedIn: 'root'
})
export class StateService{
    states: Array<State> = [];

    pop(){
        const state = this.states.pop();
        return state;
    }

    addState(state){
        this.states.push(state);
    }

    getPrevState(){
        if (this.states.length == 0){
            return null;
        } else{
            return this.states[this.states.length - 1];
        }
    }

    clearAllStates(){
        this.states = [];
    }
}
